<template>
    <b-modal class="apprentice-default-modal"
             @ok="onOk"
             :ok-title="$t('learning_path.register')"
             ok-variant="primary"
             :cancel-title="$t('common.cancel')"
             cancel-variant="outline-primary"
             hide-header
             v-model="modal"
             v-if="lpAssignment"
             size="xl">
<!--         :ok-disabled="!!full"-->

        <div class="lp-assignment-detail">
            <div class="header">
                <img :src="lpAssignment.file.path" alt="" class="banner">
            </div>

            <div class="body">
                <div class="title-wrapper">
                    <h3 class="title">{{ lpAssignment.name }}</h3>
                </div>

<!--                <div class="aside">-->
<!--                    <div class="general-info">-->
<!--                        <h5 class="title">Informatie</h5>-->
<!--&lt;!&ndash;                        <div class="company">&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="label">Berijf</div>&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="company-name">DPG Media</div>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="location">&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="label">Locatie</div>&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="location-name">Antwerpen</div>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="max-students">&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="label">Aantal leerlingen</div>&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="max-students-total">{{current}} <span v-if="lpAssignment.max_students"> van {{lpAssignment.max_students}}</span></div>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                    </div>-->

<!--                    <design-2021-learning-path-assignment-skills-component :skills-in="skillSet">-->
<!--                    </design-2021-learning-path-assignment-skills-component>-->
                </div>

                <div class="main">
<!--                    <b-alert show variant="danger" v-if="!!full">-->
<!--                        Er kan niet meer worden ingeschreven voor deze opdracht, de maximaal aantal leerlingen voor deze opdracht is bereikt-->
<!--                    </b-alert>-->

                    <div class="full-description">
                        <design-2021-apprentice-display-html-component :html-content="lpAssignment.description">
                        </design-2021-apprentice-display-html-component>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "design-2021-learning-path-detail-assignment-modal-component",
    data() {
        return {
            lpAssignment: null,
            modal: false,
            current: null,
            lpDeadlineId: null,
            skillSet: [
                {
                    id: 12,
                    title: this.$t('learning_path.social_innovation'),
                    max: "10",
                    value: 9,
                },
                {
                    id: 2,
                    title: this.$t('learning_path.digitalization'),
                    max: "10",
                    value: 7,
                },
                {
                    id: 92,
                    title: this.$t('learning_path.products'),
                    max: "10",
                    value: 3,
                },
                {
                    id: 55,
                    title: this.$t('learning_path.digital_presentation_skills'),
                    max: "10",
                    value: 5,
                },
            ],
        }
    },
    computed: {
        full() {
            return this.current >= this.lpAssignment.max_students && this.lpAssignment.max_students
        }
    },
    methods: {
        show(lpAssignmentIn, lpDeadlineIdIn) {
            this.lpAssignment = lpAssignmentIn;
            this.current = lpAssignmentIn.lp_signup_records.length;
            this.modal = true;
            this.lpDeadlineId = lpDeadlineIdIn;
        },

        onOk() {
            let data = {
                assignmentId: this.lpAssignment.id,
                deadlineId: this.lpDeadlineId,
            }
            this.axios.post(this.routes.lpAssignmentSignUp(), data).then(
                (response) => {
                    this.alert.success();
                    window.location.href = this.routes.learningPath();
                },
                (error) => {
                    this.alert.ajaxError(error)
                }
            )
        }
    }
}
</script>

<style scoped lang="scss">
    .header {
        height: 175px;
        position: relative;
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');

        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
            object-position: center;
        }
    }

    .body {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        column-gap: map-get($grid-gutter-spacing, 'sixty');

        .title .full {
            color: red;
            font-weight: bold;
        }
    }

    .aside ::v-deep {
        flex: 1 1 calc(25% - 30px);

        .title {
            color: $primary;
            font-weight: $font-weight-medium;
            border-bottom: 1px solid $primary;
        }

        .label {
            color: $primary;
            font-weight: $font-weight-medium;
            width: 125px;
            margin-right: map-get($grid-gutter-spacing,'ten');
            margin-bottom: 0;
        }

        > div:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
        }
    }

    .general-info {
        > div {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: map-get($grid-gutter-spacing, 'eight');
        }
    }

    .main {
        flex: 1 1 calc(75% - 30px);
        margin-top: map-get($grid-gutter-spacing, 'sixty');
    }

    .title-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        column-gap: map-get($grid-gutter-spacing, 'forty-two');
        flex: 1 0 100%;
        margin-bottom: $grid-gutter-width;

        .title {
            margin-bottom: 0;
        }

        .lp-assignment-full {
            font-size: $base-font-size;
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'lg')) {
        .aside ::v-deep {
            flex: 1 1 calc(30% - 30px);
        }

        .main {
            flex: 1 1 calc(70% - 30px);
            margin-top: 0;
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'xl')) {
        .aside ::v-deep {
            flex: 1 1 calc(25% - 30px);
        }

        .main {
            flex: 1 1 calc(75% - 30px);
        }
    }
</style>
